<template>
    <div id="cate-nav">
        <div id="nav-scroll" class="app-scroller">
            <div class="scroll-list app-scroller-wp">
                <ul>
                    <li v-for="(item,index) in navList"
                        :class="{active: currentNav === item.parameterId}"
                        @click="switchNav(item.parameterId,index)">
                        <span>{{item.parameterName}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    //导入模块
    import CONF from '@/app.conf.json';
    import Server from '../../services/Index';
    
    export default {
        name: "CateNav",
        props: {
            navList: {
                type: Array
            }
        },
        data() {
            return {
                currentNav: this.navList[0].parameterId,
                navWidth: ""
            }
        },
        mounted () {
            let _this = this;

            this.$emit('listenChild', {catalogueId: _this.currentNav});

                $.loadMod(MOD_URL.iscrollLite).done(function () {

                    let UA = window.navigator.userAgent;
  
                  new IScroll('.app-scroller', {
                        scrollX: true,
                        scrollY: false,
                        tap: true,
                        useTransform: (UA.match(/(MI|vivo|MX);?/i) && UA.match(/(SNEBUY-APP);?/i)) ? false : true,
                        eventPassthrough: true
                    });
                });
        },
        methods: {

            switchNav(type) {
                this.currentNav = type;
                this.$emit('listenChild', {catalogueId: type});
            }
        }
    }
</script>
<style scoped>
    #cate-nav {
        background: #fff;
        height: 82px;
        font-weight: bold;
        border-bottom: 1px solid #f2f2f2;
        ul {
            /*margin: 0 40px 0 0;*/
            li {
                font-size: 30px;
                color: #444444;
                text-align: center;
                /*width: 100px;*/
                margin: 0 20px;
                height: 1.6rem;
                span {
                    padding: 2px 15px;
                    border-radius: 3px;
                    border: 1px solid #fff;
                }

                &.active {
                    border-bottom: 4px solid #ffaa00;
                   color: #FFAA00;
                    span {
                        /*padding: 2px 15px;*/
                        /*border-radius: 3px;*/
                        /*border: 1px solid #ffaa00;*/
                    }
                }
            }
        }

        #nav-scroll {
            /*position: relative;*/
            line-height: 82px;
            overflow: hidden;
            height: 82px;

            .scroll-list {
                /*height: 100%;*/
                /*position: absolute;*/
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/CateNav.vue